import { render, staticRenderFns } from "./CallingStaffModal.vue?vue&type=template&id=af3cedd6&scoped=true&"
import script from "./CallingStaffModal.vue?vue&type=script&lang=js&"
export * from "./CallingStaffModal.vue?vue&type=script&lang=js&"
import style0 from "./CallingStaffModal.vue?vue&type=style&index=0&id=af3cedd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3cedd6",
  null
  
)

export default component.exports